module.exports = __webpack_public_path__ + "img/pic3.bc21764f.png";